import type { NotificationPreferencesTranslations } from "../interfaces/notificationPreferences";

export const notificationPreferencesTranslations: NotificationPreferencesTranslations = {
  status_coming_soon: "PRÓXIMAMENTE",
  message_show: "Ver mensaje",
  message_hide: "Ocultar mensaje",

  preview_label: "Vista previa",
  preview_verified_title: "Verificado",
  preview_language_note: "Los mensajes se envían en español",
  preview_footer: "Coloca Payments",

  test_phone_label: "Número para pruebas",
  test_phone_help:
    "Las pruebas solo llegan a este número. Así ves cada mensaje en tu celular antes de activarlo.",
  send_test_button: "Enviar prueba",
  send_test_to: "Llega a {{phone}}",
  send_test_needs_phone: "Escribe arriba un número para probar este aviso.",
  send_test_sent: "Enviado",
  send_test_placeholder: "Número de teléfono",
  send_test_invalid: "Número inválido para el país seleccionado",
  send_test_success: "Mensaje de prueba enviado por WhatsApp",
  send_test_skipped: "Ese aviso está desactivado en el servicio de WhatsApp. No se envió la prueba.",

  update_success: "Preferencia actualizada",
  active_types: "Tipos activos",
};
